<ion-content class="bg-color ion-content add-category">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <a routerLink="{{ itemList.url }}">
            {{ itemList.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <mat-card>
          <mat-card-title class="mc-title">
            <span class="org-header">Instance</span>
          </mat-card-title>
          <mat-card-content class="mc-content">
            <div class="form-container">
              <form [formGroup]="addInstanceForm" (ngSubmit)="onSubmit()">
                <div class="form-layout">

                  <mat-form-field appearance="outline">
                    <mat-label>Instance</mat-label>
                    <input type="text" formControlName="instance" matInput placeholder="Instance" required>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Ip Address</mat-label>
                    <input type="text" formControlName="ip_address" matInput placeholder="Ip Address" required>
                  </mat-form-field>
                </div>
                <div class="form-layout">
                  <mat-form-field appearance="outline">
                    <mat-label>Username</mat-label>
                    <input type="text" formControlName="username" matInput placeholder="Username" required>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>passphrase</mat-label>
                    <input [type]="hide ? 'password' : 'text'" formControlName="passphrase" matInput
                      placeholder="passphrase" required>
                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </mat-form-field>
                </div>
                <div class="form-layout">
                  <mat-form-field appearance="outline">
                    <mat-label>Hostname</mat-label>
                    <input type="text" formControlName="hostname" matInput placeholder="Hostname" required>
                  </mat-form-field>                  
                  <mat-form-field appearance="outline">
                    <mat-label>SSH Port</mat-label>
                    <input type="text" formControlName="ssh_port" matInput placeholder="SSH Port" required>
                  </mat-form-field>
                  <!-- <mat-form-field appearance="outline">
                    <mat-label>Is Default</mat-label>
                    <input type="text" formControlName="is_default" matInput placeholder="Is Default" required>
                  </mat-form-field> -->
                </div>
                <div class="form-layout">
                  <mat-form-field appearance="outline">
                    <mat-label>Port Range From</mat-label>
                    <input type="text" formControlName="port_range_from" matInput placeholder="Port Range From" required>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Port Range To</mat-label>
                    <input type="text" formControlName="port_range_to" matInput placeholder="Port Range To" required>
                  </mat-form-field>
                  
                </div>
                <div class="form-layout">
                  <div class="column-operation" style="display: flow-root;margin-left: 10px;">
                    <p style="float: left;margin-top: 15px;margin-right: 15px;">Is Default</p>
                  <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                      formControlName="is_default"
                      [value]="is_default"
                      (change)="isDefaultToggle($event)">
                      <mat-button-toggle value="0">No</mat-button-toggle>
                      <mat-button-toggle value="1">Yes</mat-button-toggle>
                    </mat-button-toggle-group>
                    </div>
                </div>
                <div class="form-layout">
                  <div class="column-operation" style="margin-left: 10px;margin-top: 20px;">
                    <p style="float: left;margin-top: 15px;margin-right: 15px;">Connection Key</p>
                      <input type="file" (change)="upload($event)" formControlName="connection_key" placeholder="Connection Key" required style="margin-top: 15px;margin-right: 15px;">
                    <!-- <p style="color: #000000; padding: 10px 0;">Upload file format </p>  -->
                    <br/>
                    <!-- <p style="margin-top: 15px;margin-right: 15px;">Connection Key Document</p> -->
                    <span >{{keyFile}} 
                      <mat-icon matTooltip="Download" matTooltipPosition="above" class="icon info" style="padding-top: 3px;"
                    (click)="download()" id="instance_update_download_logs"> save_alt </mat-icon>
                    </span>
                    </div>
                </div>
                <div class="btn-signup-grid">
                  <button mat-raised-button class="btn" routerLink="/baseapp/instances">Cancel</button>
                  <button mat-raised-button type="submit" class="btn btn-signup">Update</button>
                </div>
              </form>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <app-about-page *ngIf="hide1200"></app-about-page>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>